import React from 'react';
import { Tabs } from 'antd';
import TransportistaChoferes from '../../components/relacion/TransportistaChoferes';
import TransportistaCamiones from '../../components/relacion/TransportistaCamiones';
import { PageTitle } from '../../components/common/PageTitle';
import { theme } from '../../theme';

const Transporte: React.FC = () => {
  return (
    <div>
      <PageTitle>Transporte</PageTitle>
      <Tabs
        defaultActiveKey="choferes"
        size="small"
        style={{
          backgroundColor: 'white',
          padding: '12px',
          borderRadius: theme.borderRadius.lg,
          boxShadow: theme.shadows.md,
        }}
        items={[
          {
            key: 'choferes',
            label: 'Choferes',
            children: <TransportistaChoferes />,
          },
          {
            key: 'camiones',
            label: 'Camiones',
            children: <TransportistaCamiones />,
          },
        ]}
      />
    </div>
  );
};

export default Transporte;

